import type { Event, EventHint } from '@sentry/react';

export const isAxiosNetworkErrorInSentry = (
  event: Event,
  hint: EventHint,
): boolean => {
  const original = hint.originalException;
  if (original !== null && typeof original === 'object') {
    const err = original as { name?: string; message?: string };
    if (err.name === 'AxiosError' && err.message === 'Network Error') {
      return true;
    }
  }

  const values = event.exception?.values;
  const top = values?.[0];
  if (top?.type === 'AxiosError') {
    const text = top.value ?? '';
    if (text === 'Network Error' || text.startsWith('Network Error')) {
      return true;
    }
  }

  return false;
};
